<template>
  <div class="bg1" ref="setH" style="padding: 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="头部轮播大图" name="1">
        <el-button
          type="primary"
          size="small"
          class="poatr"
          @click="
            dialogVisible = true;
            imageType = 1;
            imageUrl = '';
            imageUrl1 = '';
            linkUrl = '';
            imageSort = '';
          "
          >添加</el-button
        >
        <el-table :data="tableData['1']" style="width: 100%" border>
          <el-table-column label="宣传图（600*290）" width="180">
            <template slot-scope="scope">
              <!-- <img :src="scope.row.imageUrl" alt="" style="width: 160px" /> -->
              <el-image
                style="width: 50px; height: 50px"
                :src="qianzhui + scope.row.imageUrl"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="linkUrl" label="快捷链接"> </el-table-column>
          <el-table-column prop="imageSort" label="排序" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.imageSort"
                placeholder="请选择"
                size="small"
                @change="currentSel(scope.row)"
                style="width: 90px"
              >
                <el-option
                  v-for="item in sortFun(tableData['1'], scope.row.imageSort)"
                  :key="item"
                  :label="item == 9 ? '不显示' : item"
                  :value="item"
                >
                </el-option> </el-select
            ></template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="
                  dialogVisible1 = true;
                  imageType = 1;
                  imageUrl = scope.row.imageUrl;
                  linkUrl = scope.row.linkUrl;
                  imageSort = scope.row.imageSort;
                  id = scope.row.id;
                "
                size="small"
                >修改</el-button
              >
              <el-button type="danger" @click="del(scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="头部轮播小图" name="2"
        ><el-button
          type="primary"
          size="small"
          class="poatr"
          @click="
            dialogVisible = true;
            imageType = 2;
            imageUrl = '';
            linkUrl = '';
            imageUrl1 = '';
            imageSort = '';
          "
          >添加</el-button
        >
        <el-table :data="tableData['2']" style="width: 100%" height="400" border>
          <el-table-column label="宣传图（190*110）" width="180">
            <template slot-scope="scope">
              <!-- <img :src="scope.row.imageUrl" alt="" style="width: 160px" /> -->
              <el-image
                style="width: 50px; height: 50px"
                :src="qianzhui + scope.row.imageUrl"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="linkUrl" label="快捷链接"> </el-table-column>
          <el-table-column prop="imageSort" label="排序" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.imageSort"
                placeholder="请选择"
                size="small"
                style="width: 90px"
                @change="currentSel(scope.row)"
              >
                <el-option
                  v-for="item in sortFun(tableData['2'], scope.row.imageSort)"
                  :key="item"
                  :label="item == 9 ? '不显示' : item"
                  :value="item"
                >
                </el-option> </el-select
            ></template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="
                  dialogVisible1 = true;
                  imageType = 2;
                  imageUrl = scope.row.imageUrl;
                  linkUrl = scope.row.linkUrl;
                  imageSort = scope.row.imageSort;
                  id = scope.row.id;
                "
                size="small"
                >修改</el-button
              >
              <el-button type="danger" @click="del(scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table></el-tab-pane
      >
      <el-tab-pane label="页中宣传图" name="3"
        ><el-button
          type="primary"
          size="small"
          class="poatr"
          @click="
            dialogVisible = true;
            imageType = 3;
            imageUrl = '';
            imageUrl1 = '';
            linkUrl = '';
            imageSort = '';
          "
          >添加</el-button
        >
        <el-table :data="tableData['3']" style="width: 100%" height="400" border>
          <el-table-column label="宣传图（1200*140）" width="180">
            <template slot-scope="scope">
              <!-- <img :src="scope.row.imageUrl" alt="" style="width: 160px" /> -->
              <el-image
                style="width: 50px; height: 50px"
                :src="qianzhui + scope.row.imageUrl"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="linkUrl" label="快捷链接"> </el-table-column>
          <el-table-column prop="imageSort" label="排序" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.imageSort"
                placeholder="请选择"
                size="small"
                style="width: 90px"
                @change="currentSel(scope.row)"
              >
                <el-option
                  v-for="item in sortFun(tableData['3'], scope.row.imageSort)"
                  :key="item"
                  :label="item == 9 ? '不显示' : item"
                  :value="item"
                >
                </el-option> </el-select
            ></template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="
                  dialogVisible1 = true;
                  imageType = 3;
                  imageUrl = scope.row.imageUrl;
                  linkUrl = scope.row.linkUrl;
                  imageSort = scope.row.imageSort;
                  id = scope.row.id;
                "
                size="small"
                >修改</el-button
              >
              <el-button type="danger" @click="del(scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table></el-tab-pane
      >
    </el-tabs>
    <!-- // -->
    <el-dialog title="新增轮播图" :visible.sync="dialogVisible" width="700px">
      <div style="overflow: hidden">
        <div>
          <div class="search">
            <em>上传图片</em
            ><el-input
              v-model="imageUrl"
              placeholder="请输入内容"
              size="small"
              disabled
              style="
                float: left;
                margin-right: 15px;
                max-width: 400px;
                width: 400px;
              "
            ></el-input>
            <el-upload
              action="wwm"
              :limit="1"
              :http-request="uploadSectionFile"
              ref="upload"
              :show-file-list="false"
              style="float: left"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="search">
            <em>链接地址</em
            ><el-input
              v-model="linkUrl"
              placeholder="请输入内容"
              size="small"
              style="max-width: 400px; width: 400px"
            ></el-input>
            <p style="padding: 10px 0 0 95px; font-size: 12px; color: #bdbdbd">
              例子:https://www.baidu.com/
            </p>
          </div>
          <div class="search">
            <em>排序</em
            ><el-select
              v-model="imageSort"
              placeholder="请选择"
              size="small"
              style="width: 90px"
            >
              <el-option
                v-for="item in sortFun(tableData[imageType], '')"
                :key="item"
                :label="item == 9 ? '不显示' : item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <img
          :src="imageUrl1"
          alt=""
          style="max-height: 300px; max-width: 790px"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add()" size="small">添 加</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改轮播图" :visible.sync="dialogVisible1" width="700px">
      <div style="overflow: hidden">
        <div>
          <div class="search">
            <em>上传图片</em
            ><el-input
              v-model="imageUrl"
              placeholder="请输入内容"
              disabled
              size="small"
              style="
                float: left;
                margin-right: 15px;
                max-width: 400px;
                width: 400px;
              "
            ></el-input>
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :limit="1"
              :http-request="uploadSectionFile"
              ref="upload1"
              :show-file-list="false"
              style="float: left"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="search">
            <em>链接地址</em
            ><el-input
              v-model="linkUrl"
              placeholder="请输入内容"
              size="small"
              style="max-width: 400px; width: 400px"
            ></el-input>
            <p style="padding: 10px 0 0 95px; font-size: 12px; color: #bdbdbd">
              例子:https://www.baidu.com/
            </p>
          </div>
          <div class="search">
            <em>排序</em
            ><el-select
              v-model="imageSort"
              placeholder="请选择"
              size="small"
              style="width: 90px"
            >
              <el-option
                v-for="item in sortFun(tableData[imageType], '')"
                :key="item"
                :label="item == 9 ? '不显示' : item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <img
          :src="imageUrl1"
          alt=""
          style="max-height: 300px; max-width: 790px"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="modify()" size="small"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import upload from "../../mixins/upload";
export default {
  data() {
    return {
      activeName: "1",
      tabH: 0,
      qianzhui: window.sessionStorage.getItem("uploadUrl"),
      tableData: {
        1: [],
        2: [],
        3: [],
      },
      sort: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      dialogVisible: false,
      dialogVisible1: false,
      imageUrl: "",
      imageUrl1: "",
      linkUrl: "",
      imageSort: "",
      imageType: 1,
      id: "",
    };
  },
  mixins: [upload],
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 100;
    });
    this.getData();
  },
  methods: {
    async uploadSectionFile(params) {
      await this.upload(params).then((file) => {
        this.imageUrl = file.url;
        this.imageUrl1 = window.sessionStorage.getItem("uploadUrl") + file.url;
        this.$refs.upload.clearFiles();
        this.$refs.upload1.clearFiles();
      });
    },
    handleClick() {
      this.getData(this.activeName);
    },
    del(v) {
      this.$confirm("是否删除轮播图?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax
            .post("/server/record/image/deleteRecordImage", {
              id: v.id,
              imageType: v.imageType,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getData(this.activeName);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    modify(v) {
      if (!this.imageSort) {
        this.$message.error("请选择排序！");
        return false;
      }
      this.$ajax
        .post("/server/record/image/editRecordImage", {
          imageUrl: this.imageUrl,
          linkUrl: this.linkUrl,
          imageSort: this.imageSort,
          imageType: this.imageType,
          id: this.id,
        })
        .then((res) => {
          this.dialogVisible1 = false;
          this.getData(this.activeName);
        });
    },
    add() {
      if (!this.imageSort) {
        this.$message.error("请选择排序！");
        return false;
      }
      this.$ajax
        .post("/server/record/image/saveRecordImage", {
          imageUrl: this.imageUrl,
          linkUrl: this.linkUrl,
          imageType: this.imageType,
          imageSort: this.imageSort,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getData(this.activeName);
        });
    },
    sortFun(a, v) {
      let b;
      if (v) {
        b = [v, 9];
      } else {
        b = [9];
      }
      return Array.from(
        new Set(
          this.sort
            .filter((el) => !a.map((e) => e.imageSort).includes(el))
            .concat(b)
        )
      ).sort();
    },
    getData(v = 1) {
      this.$ajax
        .post("/server/record/image/getImageList", {
          imageType: v,
        })
        .then((res) => {
          this.tableData[v] = res;
        });
    },
    // 排序
    currentSel(v) {
      this.$ajax
        .post("/server/record/image/editRecordImage", {
          imageUrl: v.imageUrl,
          linkUrl: v.linkUrl,
          imageSort: v.imageSort,
          imageType: v.imageType,
          id: v.id,
        })
        .then((res) => {
          this.dialogVisible1 = false;
          this.getData(this.activeName);
        });
    },
  },
};
</script>

<style>
.el-tabs__item {
  height: 53px;
  line-height: 53px;
}
.el-tabs__content {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/banner.vue